import { assoc, compose, map, pick, prop } from 'ramda'

export const cleanRequest = map(item =>
  compose(
    pick(['id', 'name', 'userGroupIds', 'placeLevelIds', 'checklistTypeIds', 'assetIds']),
    assoc('userGroupIds', !item.userGroups?.length ? [] : map(prop('id'), item.userGroups || [])),
    assoc('checklistTypeIds', !item.checklistTypes?.length ? [] : map(prop('id'), item.checklistTypes || [])),
    assoc('placeLevelIds', !item.placeLevels?.length ? [] : map(prop('id'), item.placeLevels || [])),
    assoc('assetIds', !item.assets?.length ? [] : map(prop('id'), item.assets || []))
  )(item)
)
